// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {CircleCommonLayout} from 'app_components/commons/circle'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface ICircleCommonProps {
  size?: any
  color?: any
  tooltip?: {placement: 'top' | 'left' | 'bottom' | 'right', label: string}
}
interface ICircleCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CircleCommon extends Component<ICircleCommonProps, ICircleCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICircleCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <CircleCommonLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(CircleCommon)
